module.exports = __webpack_public_path__ + "img/product3ap.261db1da.png";